'use client';

import React, { forwardRef } from 'react';
import type { AvatarProps } from '@mui/material/Avatar';
import Avatar from '@mui/material/Avatar';
import { Image } from './image';
import CircularProgress from '@mui/material/CircularProgress';

type AvatarSize = 'xs2' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xl2' | 'onboardingSize' | 'default';

interface Props extends AvatarProps {
  placeholder?: string | null;
  imageProps?: Parameters<typeof Image>[0];
  size?: AvatarSize;
  htmlFor?: string;
  loading?: boolean;
}

const progressSize: Record<AvatarSize, number> = {
  default: 20,
  xs2: 10,
  xs: 14,
  sm: 20,
  md: 25,
  lg: 35,
  xl: 50,
  xl2: 75,
  onboardingSize: 30,
};

const CustomAvatar = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { placeholder, src, imageProps, className, size = 'default', loading, ...rest } = props;

  return (
    <Avatar className={[className, size].join('')} ref={ref} {...rest}>
      {loading ? (
        <CircularProgress size={progressSize[size]} />
      ) : src ? (
        <Image {...imageProps} src={src} width="inherit" height="inherit" />
      ) : (
        placeholder?.[0]
      )}
    </Avatar>
  );
});

export default CustomAvatar;
